import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { ChevronDown, PatchCheckFill, Sliders, Tags, XLg } from 'react-bootstrap-icons'
import ProviderFilters from './SearchBarParts/ProviderFilters'
import SearchField from './SearchBarParts/SearchField'
import SearchByTag from './SearchBarParts/SearchByTag'
import SelectedFilters from './SearchBarParts/SelectedFilters'
import AddInfluencerMenu from './SearchBarParts/AddInfluencerMenu'
import WaitingListButton from './SearchBarParts/WaitingListButton'
import { SearchContext } from '../../../contexts/SearchContext'
import { CurrentProjectManagerContext } from '../../../contexts/CurrentProjectManagerContext'
import { activeFilterChips, hasAnyRefinement } from '../../../utils/influencerSearchFilters'

const secondaryButton = 'flex h-10 items-center gap-2 rounded-lg border-1 border-border-primary dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode px-3 text-sm font-semibold text-rb-black dark:text-white hover:bg-rb-grey dark:hover:bg-rb-dark-mode-lighter'

export default observer(function SearchBar() {
  const { search, filtersOpen, toggleFiltersOpen, waitingListModalOpen, newAuthenticationModalOpen, toggleNewAuthenticationModal, toggleNewInfluencerModal, toggleWaitingListModal, toggleTagsModal, resetSearch } = useContext(SearchContext)
  const { currentProjectManager } = useContext(CurrentProjectManagerContext)

  const chips = activeFilterChips(search)
  const refined = hasAnyRefinement(search)

  return (
    <div className="relative z-10 border-b-1 border-border-primary dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode">
      <div className="mx-auto max-w-[1400px] px-8 pt-6 pb-4">
        <div className="flex items-center justify-between gap-4">
          <h1 className="text-2xl font-bold text-rb-black dark:text-white">Influencers</h1>
          <div className="flex items-center gap-2">
            <WaitingListButton onClick={toggleWaitingListModal} refreshKey={`${waitingListModalOpen}-${newAuthenticationModalOpen}`} className={secondaryButton} />
            {currentProjectManager?.is_admin && (
              <button type="button" onClick={toggleTagsModal} className={secondaryButton}>
                <Tags />
                Manage tags
              </button>
            )}
            <AddInfluencerMenu onPull={toggleNewAuthenticationModal} onCreateManually={toggleNewInfluencerModal} />
          </div>
        </div>

        <div className="mt-5 flex items-center gap-2">
          <ProviderFilters />
          <SearchField />
          <SearchByTag />
          <button
            type="button"
            onClick={() => search.reachbird_approved = !search.reachbird_approved}
            title="Only creators with at least one completed Reachbird collaboration"
            className={`flex h-11 shrink-0 items-center gap-2 rounded-lg px-3 text-sm font-semibold transition-colors ${search.reachbird_approved ? 'bg-rb-light-green dark:bg-rb-green/15 text-rb-black dark:text-white ring-1 ring-inset ring-rb-green' : 'border-1 border-rb-lite-grey dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode text-rb-mat-grey dark:text-gray-300 hover:bg-rb-grey dark:hover:bg-rb-dark-mode-lighter'}`}
          >
            <PatchCheckFill className="text-rb-green" />
            Reachbird Approved
          </button>
          <button
            type="button"
            onClick={toggleFiltersOpen}
            className={`flex h-11 shrink-0 items-center gap-2 rounded-lg px-3 text-sm font-semibold transition-colors ${filtersOpen || chips.length ? 'bg-rb-light-green dark:bg-rb-green/15 text-rb-black dark:text-white ring-1 ring-inset ring-rb-green' : 'border-1 border-rb-lite-grey dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode text-rb-mat-grey dark:text-gray-300 hover:bg-rb-grey dark:hover:bg-rb-dark-mode-lighter'}`}
          >
            <Sliders />
            Filters
            {chips.length > 0 && <span className="flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-rb-green px-1.5 text-xs text-white dark:text-rb-dark-mode">{chips.length}</span>}
            <ChevronDown className={`text-xs transition-transform ${filtersOpen ? 'rotate-180' : ''}`} />
          </button>
        </div>

        {(chips.length > 0 || refined) && (
          <div className="mt-3 flex flex-wrap items-center gap-2">
            {chips.map(chip => (
              <span key={chip.key} className="inline-flex h-7 items-center gap-1.5 rounded-full bg-rb-grey dark:bg-rb-dark-mode-lighter pl-3 pr-1.5 text-xs font-medium text-rb-black dark:text-white">
                {chip.label}
                <button type="button" onClick={chip.clear} title="Remove filter" className="rounded-full p-1 hover:bg-gray-200 dark:hover:bg-rb-dark-mode">
                  <XLg className="text-[10px]" />
                </button>
              </span>
            ))}
            {refined && (
              <button type="button" onClick={resetSearch} className="text-xs font-semibold text-rb-green hover:underline">
                Clear all
              </button>
            )}
          </div>
        )}
      </div>

      {filtersOpen && <SelectedFilters />}
    </div>
  )
})
